import React, { useEffect, useState } from "react";
import classes from "./MainProfile.module.scss";
import { Button } from "@mui/material";
import RewardImage from "../../assets/Images/rewardImage.svg";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import { getIntroducerDetailsAPICall } from "../../Utils/APICalls";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import { Helmet } from "react-helmet";

export default function MainProfile() {
  const [Introducerdetails, setIntroducerDetails] = useState({
    Address1: "",
    Address2: "",
    Address3: "",
    BankAccountNumber: "",
    BankName: "",
    BranchName: "",
    Country: "",
    Email: "",
    IFSCcode: "",
    IntroducerCode: "",
    Mobile: "",
    PanNo: "",
    Pin: "",
  });
  const userDetails: any = sessionStorage.getItem("userDetails");
  const UserDetails: any = JSON.parse(userDetails);
  const totalAmount: any = sessionStorage.getItem("totalAmount");
  useEffect(() => {
    getIntroducerDetailsAPICall()
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", responseData.data);
        setIntroducerDetails(responseData.data);
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>Profile</title>
        <meta name="Profile" content="Profile" />
      </Helmet>
    <div className={classes.mainWrapper}>
      <div className={classes.leftContainerTopTitle}>
        {/* <p className={classes.welcomeText}>
          Welcome {UserDetails ? UserDetails.Name : ""}
        </p> */}
        <p className={classes.dashboardText}>Profile</p>
      </div>

      <div className={classes.topContainer}>
        <div className={classes.topContainerSection}>
          <div className={classes.leftSection}>
            <div className={classes.leftSectionAvatar}>
              {UserDetails ? UserDetails.Name.slice(0, 2) : ""}
            </div>
            <div className={classes.leftSectiontitleContainer}>
              <p className={classes.leftSectionUserName}>
                {UserDetails ? UserDetails.Name : ""}
              </p>
              <p className={classes.leftSectionUserDes}>
                Introduce Code {Introducerdetails.IntroducerCode}
              </p>
            </div>
          </div>
          {/* <div className={classes.rightSection}>
            <Button
              // onClick={handleClickOpen}
              variant="outlined"
              sx={{
                borderColor: "rgba(0, 103, 121, 1)",
                backgroundColor: "rgba(0, 103, 121, 1)",
                color: "#FFFFFF",
                borderRadius: "5px",
                padding: "8px 20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "12px",
                "&:hover": {
                  backgroundColor: "rgba(0, 103, 121, 1)",
                  borderColor: "rgba(0, 103, 121, 1)",
                  color: "white",
                },
              }}
            >
              {" "}
              Complete KYC
            </Button>
          </div> */}
        </div>
      </div>

      <div className={classes.centerContainer}>
        <div className={classes.centerContainerLeftContainer}>
          <div className={classes.detailsDiv}>
            <div className={classes.iconContainer}>
              <PhoneIphoneOutlinedIcon sx={{ fontSize: "18px" }} />
            </div>
            <p className={classes.mobileText1}>Mobile</p>
            <p className={classes.mobileText}>-</p>
            <p className={classes.mobileText}>
              {UserDetails ? UserDetails.Mobile : ""}
            </p>
          </div>
          <div className={classes.detailsDiv}>
            <div className={classes.iconContainer}>
              <EmailOutlinedIcon sx={{ fontSize: "18px" }} />
            </div>
            <p className={classes.mobileText1}>Email</p>
            <p className={classes.mobileText}>-</p>
            <p className={classes.mobileText}>
              {UserDetails ? UserDetails.Email : ""}
            </p>
          </div>
          <div className={classes.detailsDiv}>
            <div className={classes.iconContainer}>
              <AssuredWorkloadIcon sx={{ fontSize: "18px" }} />
            </div>
            <p className={classes.mobileText1}>PAN</p>
            <p className={classes.mobileText}>-</p>
            <p className={classes.mobileText}>{Introducerdetails.PanNo}</p>
          </div>
        </div>
        <div className={classes.centerContainerRightContainer}>
          <div className={classes.detailsDiv}>
            <div className={classes.iconContainer}>
              <AccountBalanceOutlinedIcon sx={{ fontSize: "18px" }} />
            </div>
            <p className={classes.mobileText1}>Bank</p>
            <p className={classes.mobileText}>-</p>
            <p className={classes.mobileText}>{Introducerdetails.BankName}</p>
          </div>
          <div className={classes.detailsDiv}>
            <div className={classes.iconContainer}>
              <AccountBalanceWalletIcon sx={{ fontSize: "18px" }} />
            </div>
            <p className={classes.mobileText1}>Bank A/c</p>
            <p className={classes.mobileText}>-</p>
            <p className={classes.mobileText}>
              {Introducerdetails.BankAccountNumber}
            </p>
          </div>

          {/* <div className={classes.detailsDiv}>
            <div className={classes.iconContainer}>
              <PhoneIphoneOutlinedIcon sx={{fontSize:'18px'}}/>
            </div>
            <p className={classes.mobileText1}>Mobile</p>
            <p className={classes.mobileText}>-</p>
            <p className={classes.mobileText}>(+91)80981254789</p>
          </div> */}
        </div>
      </div>
      <p className={classes.rewardText}>Reward</p>
      <div className={classes.bottomContainer}>
        <div className={classes.bottomContainerTextSection}>
          <p className={classes.rewardBalanceText}>Reward Balance</p>
          <p className={classes.amountText}>
            ₹{Math.floor(parseFloat(totalAmount.toString()))}
          </p>
        </div>
        <div>
          <img src={RewardImage} />
        </div>
      </div>
    </div>
    </>
  );
}
